import type { AuditEntry } from '@/api/types'

/**
 * Field names as the audit trail stores them, in words. The trail keeps the
 * column name so it stays exact; people should not have to read "HoursWorked".
 */
const FIELD_LABELS: Record<string, string> = {
  HoursWorked: 'Hours',
  Amount: 'Amount',
  JobNo: 'Job',
  DateWorked: 'Date',
  CostCode: 'Cost code',
  EarningsCode: 'Earnings code',
  LaborCode: 'Labor code',
  EntryType: 'Entry type',
}

/**
 * One change from the correction history: Added / Updated / Deleted, the
 * field, and old → new.
 *
 * Shared by a crew day's Correction history and the office's Changes by week,
 * so the two describe a change the same way. For Added and Deleted the stored
 * field is the work type or earnings code of the line, which the Work type
 * column now shows, so it is not repeated here.
 */
export function ChangeCell({ a }: { a: AuditEntry }) {
  const field =
    a.action === 'Updated' ? (FIELD_LABELS[a.field_name ?? ''] ?? a.field_name) : null
  return (
    <>
      <span
        className={`badge ${
          a.action === 'Deleted' ? 'badge-error' : a.action === 'Added' ? 'badge-ok' : 'badge-info'
        }`}
      >
        {a.action === 'Deleted' ? 'Removed' : a.action}
      </span>{' '}
      {field}
      {a.old_value !== null && (
        <>
          {' '}
          <span className="muted">{a.old_value}</span> →{' '}
          <strong>{a.new_value ?? 'removed'}</strong>
        </>
      )}
      {a.old_value === null && a.new_value && (
        <>
          {' '}
          <strong>{a.new_value}</strong>
        </>
      )}
    </>
  )
}
